/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Neat_Gross_Dove_ClaspInputs */

const en_neat_gross_dove_clasp = /** @type {(inputs: Neat_Gross_Dove_ClaspInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detractors`)
};

const de_neat_gross_dove_clasp = /** @type {(inputs: Neat_Gross_Dove_ClaspInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detraktoren`)
};

/**
* | output |
* | --- |
* | "Detractors" |
*
* @param {Neat_Gross_Dove_ClaspInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const neat_gross_dove_clasp = /** @type {((inputs?: Neat_Gross_Dove_ClaspInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neat_Gross_Dove_ClaspInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_neat_gross_dove_clasp(inputs)
	return de_neat_gross_dove_clasp(inputs)
});